'use client';

// Hàng đợi GIÃN CÁCH lúc khởi động (2026-10-30, docs/error-logging.md § React #185) — bổ sung cho
// `shared-update-batcher.ts` (gom KẾT QUẢ sau khi trả lời), còn đây giãn cách lúc XUẤT PHÁT. Các
// Provider dùng chung (Building/Tenant/Permissions/Todos/ChatInbox, xem `components/AppShell.tsx`)
// đều tự gọi getDoc/getDocs/onSnapshot gần như ĐỒNG THỜI lúc mount — dưới mạng yếu các request này
// tranh băng thông + hoàn thành RẢI RÁC khó đoán, kéo dài cascade boot và tăng khả năng vượt
// NESTED_UPDATE_LIMIT của React 19 (bằng chứng trực tiếp: clip Trân 30/10/2026, sóng wifi yếu trùng
// khớp cụm crash /pricing). KHÔNG chờ XONG mới gọi tiếp (sẽ làm app mở chậm hẳn cho user mạng tốt) —
// chỉ đảm bảo lượt SAU xuất phát trễ hơn lượt TRƯỚC tối thiểu STAGGER_MS, giảm số request tranh băng
// thông CÙNG LÚC trên mạng yếu mà gần như không ảnh hưởng tốc độ trên mạng tốt (vẫn chạy chồng lấp,
// chỉ lệch thời điểm bắt đầu).
import { useSyncExternalStore } from 'react';

const STAGGER_MS = 90;
let lastStart = 0;
let queueTail: Promise<void> = Promise.resolve();
let activeCount = 0;
const listeners = new Set<() => void>();
function notify(): void { for (const l of listeners) l(); }

/**
 * Xếp `start` (hàm KHỞI ĐỘNG 1 lần gọi mạng — getDoc/getDocs/onSnapshot) vào hàng đợi giãn cách.
 * Trả promise resolve với kết quả của `start()` (flatten tự nhiên nếu `start` trả về Promise) —
 * caller `await`/`.then()` như gọi thẳng, chỉ khác thời điểm XUẤT PHÁT bị trễ theo lượt.
 */
export async function scheduleBootCall<T>(start: () => T): Promise<Awaited<T>> {
  activeCount++; notify();
  const myTurn = queueTail.then(() => new Promise<void>(resolve => {
    const wait = Math.max(0, lastStart + STAGGER_MS - Date.now());
    setTimeout(() => { lastStart = Date.now(); resolve(); }, wait);
  }));
  queueTail = myTurn;
  await myTurn;
  try {
    return await start();
  } finally {
    activeCount--; notify();
  }
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}
function getSnapshot(): boolean { return activeCount > 0; }
function getServerSnapshot(): boolean { return false; }

/** true khi còn lời gọi boot CHƯA TỚI LƯỢT xuất phát — UI dùng hiện animation xoay nhẹ lúc boot. */
export function useBootQueueActive(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
